import { render, staticRenderFns } from "./DocumentDetailsData.vue?vue&type=template&id=1b281e92&"
import script from "./DocumentDetailsData.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsData.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailsData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports